export const CREATING_REEL = "CREATING_REEL";
export const UPDATING_REEL = "UPDATING_REEL";
export const REEL_CREATED = "REEL_CREATED";
export const REEL_UPDATED = "REEL_UPDATED";
export const ERROR_REEL_CREATE = "ERROR_REEL_CREATE";
export const ERROR_REEL_UPDATE = "ERROR_REEL_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
